export { default } from './FinanciamentoDeMotos25Blog';
